import React from 'react';
import egg1 from './egg1.png';
import egg2 from './egg2.png';
import egg3 from './egg3.png';
import egg4 from './initialegg.png';
import audioFile from './pingguo.mp3';

class InitialSequence extends React.Component {
  state = {
    stage: 0,
    clicks: 0,
  };

  audioRef = React.createRef();

  componentDidMount() {
    this.interval = setInterval(() => {
      if (this.state.stage > 0 && this.state.stage < 6) {
        this.setState((prevState) => ({
          stage: prevState.stage + 1,
        }));
      }
    }, 1000); // changes state every 1 seconds
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  playAudio = () => {
    this.audioRef.current.play();
    this.setState({ stage: 1 });
  }

  handleClick = () => {
    this.setState((prevState) => ({
      clicks: prevState.clicks + 1,
    }));

    if (this.state.clicks >= 9) {
      clearInterval(this.interval);
      this.setState({ stage: 7 });
    }
  };

  render() {
    const { stage, clicks } = this.state;

    let eggImage = egg1;
    if (clicks >= 5 && clicks < 10) {
      eggImage = egg2;
    } else if (clicks >= 10) {
      eggImage = egg3;
    }

    return (
      <div className ="inibg" style={{ width: '80%', height: 'auto', marginLeft: "auto", marginRight: "auto" }}>
      <div style={{ textAlign: 'center', marginTop: '5%', marginBottom: '5%' }}>
        {stage === 0 && 
          <button onClick={this.playAudio} style={{ 
      backgroundColor:'#ffdb38', 
      color: "#000000",
      width: '25%', 
      height: 'auto',
      padding: '15px', 
      fontSize: '2vw', 
      fontWeight: 'bold', 
      border: '10vw',
      boxShadow: '0px 1vw 3vw rgba(0,0,0,0.3)', // adds a soft shadow to give a lifting effect
      borderRadius: '80px', // round the corners a bit for a better 3D effect
      transition: 'all 0.3s ease', // transition effect for the button when pressed
    }}
    onMouseDown={e => e.currentTarget.style.transform = 'scale(0.90)'} // reduce size a bit when pressed
    onMouseUp={e => e.currentTarget.style.transform = ''} // return to original size when released
    onMouseLeave={e => e.currentTarget.style.transform = ''} // return to original size when mouse leaves
  >
            START ROLL <br /> 开启蛋卷
          </button>
        }
        <audio ref={this.audioRef} src={audioFile} loop />
        {stage >= 1 && <img src={egg4} alt="egg" style={{ marginTop: '5%', width: '20%', height: '20%' }} />}
        {stage >= 2 && <h1 style={{ fontSize: '2vw' }}>HELLO 你好</h1>}
        {stage >= 3 && <h1 style={{ fontSize: '2vw' }}>WHERE EGGMAN? 找蛋哥？</h1>}
        {stage >= 4 && <h1 style={{ fontSize: '2vw' }}>LIKE EGGS? 喜欢吃蛋？</h1>}
        {stage >= 5 && <h1 style={{ fontSize: '2vw' }}>STRAPON42069! 绑枪出发42069!</h1>}
        
        {stage >= 6 && (
          <div>
            <img src={eggImage} alt="egg" onClick={this.handleClick} style={{ cursor: 'pointer', width: '20%', height: '20%' }} />
            <h1 style={{fontSize: '2vw', color:"red", paddingBottom: '2vw'}}>{clicks < 10 ? `CRACK IT! 敲破它！[${clicks}/42069]` : 'YOU ARE WORTHY! 蛋哥欢迎你！'}</h1>
          </div>
        )}
        {stage >= 7 && 
  <button 
    onClick={this.props.onFinished} 
    style={{ 
      backgroundColor:'#ffdb38', 

      width: '25%', 
      height: 'auto', 
      fontSize: '2vw', 
      fontWeight: 'bold', 
      marginBottom:'5%',
      padding: '15px',
      border: '10vw',
      boxShadow: '0px 1vw 3vw rgba(0,0,0,0.3)', // adds a soft shadow to give a lifting effect
      borderRadius: '80px', // round the corners a bit for a better 3D effect
      transition: 'all 0.3s ease', // transition effect for the button when pressed
    }}
    onMouseDown={e => e.currentTarget.style.transform = 'scale(0.90)'} // reduce size a bit when pressed
    onMouseUp={e => e.currentTarget.style.transform = ''} // return to original size when released
    onMouseLeave={e => e.currentTarget.style.transform = ''} // return to original size when mouse leaves
  >
    ENTER 进入
  </button>
}
</div>
</div>
    );
  }
}

export default InitialSequence;
